import { MgState, UnitEntityInterface, UnitQueryInterface } from '@types';
import { createSelector } from 'reselect';
import { hasFeaturePermissionsSelectorFactory } from '@selectors/user';
import { FeaturePermission, PagePermission, PermissionActions } from '../../api/enums';

export const unitsFiltersSelector = (store: MgState): UnitQueryInterface =>
  store?.unit?.unitsFilters;

export const unitsSelector = (store: MgState): UnitEntityInterface[] => store?.unit?.units;

export const unitsTotalSelector = (store: MgState): number => store?.unit?.total;

export const unitsPageNumberSelector = createSelector([unitsFiltersSelector], (filters) => {
  return filters?.offset / filters?.limit;
});

export const unitsRowsPerPageSelector = createSelector(
  [unitsFiltersSelector],
  (filters) => filters?.limit
);

export const unitsTotalPagesSelector = createSelector(
  [unitsFiltersSelector, unitsTotalSelector],
  (filters, total) => Math.ceil(total / filters?.limit)
);

export const canUpdateUnitRoleSelector = createSelector(
  [
    hasFeaturePermissionsSelectorFactory(
      PagePermission.Management,
      [FeaturePermission.ManagementUnits],
      [PermissionActions.Update]
    ),
  ],
  (canUpdateUnitRole) => canUpdateUnitRole
);
